module.exports = __webpack_public_path__ + "static/img/logo.805e06e8.png";